import React, { useState } from "react";
import { Download, LogIn } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import api, { API } from "@/lib/api";

export default function FreeDownloadButton({ resource, className }) {
  const { user, login } = useAuth();
  const [optIn, setOptIn] = useState(false);

  if (resource.requires_login && !user) {
    return (
      <Button onClick={() => { toast.info("Sign in with Google to download — it's free."); login(); }} className={className} data-testid={`resource-signin-${resource.id}`}>
        <LogIn className="w-4 h-4" /> Sign in to download free
      </Button>
    );
  }

  const onDownload = () => {
    toast.success(`${resource.title} download started`);
    if (optIn && user?.email) {
      api.post("/marketing/opt-in", { email: user.email, name: user.name || "", source: "free download" })
        .then(() => toast.success("You're on the list — unsubscribe any time."))
        .catch(() => {});
    }
  };

  return (
    <div className="space-y-2">
      <Button asChild className={className} data-testid={`resource-download-${resource.id}`}>
        <a href={`${API}/resources/${resource.id}/free`} target="_blank" rel="noreferrer" onClick={onDownload}>
          <Download className="w-4 h-4" /> Download free
        </a>
      </Button>
      {user && (
        <label className="flex items-start gap-2 text-xs text-slate-600 cursor-pointer select-none">
          <input type="checkbox" checked={optIn} onChange={(e) => setOptIn(e.target.checked)}
                 className="mt-0.5 w-3.5 h-3.5 rounded border-slate-300 text-teal-600 focus:ring-teal-500 shrink-0"
                 data-testid={`resource-optin-${resource.id}`} />
          <span>Email me occasional teaching tips and new resources. Unsubscribe any time.</span>
        </label>
      )}
    </div>
  );
}
